module.exports = __webpack_public_path__ + "img/gmy_business.c951ecb6.png";